<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="overflow-y-auto h-screen introduction-content-height" v-if="introductionData">
            <div class="mx-4">
                <figure>
                    <img class="rounded-lg" :src="introductionData.image_url" />
                </figure>
                <div class="my-6 mb-96 pb-48 sm:mb-20">
                    <h1 class="text-lg font-bold mb-3">{{ introductionData.title }}</h1>
                    <div
                        class="text-base-content text-base font-medium text_overflow pb-3"
                    >
                        <span v-readMore:200="introductionData.description"></span>
                    </div>
                    <div v-html="introductionData.embed_code"></div>
                    <div class="text-center flex flex-col gap-3 z-100">
                        <label @click="$emit('closed')" class="btn btn-primary"
                            >{{ trans.show_map }}</label
                        >
                        <a
                            :href="introductionData.link"
                            class="btn-link btn-sm link-secondary"
                            target="__blank"
                            >{{ introductionData.link_title }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ReadMoreDirective from '../custom_directives/ReadMore';

export default {
    directives: {
        'readMore' : ReadMoreDirective
    },
    props: {
        introductionData: {
            type: Object,
            default: function () {
                return null;
            },
        },
        trans: {
            type: Object,
            required: true
        },
    },
};
</script>

<style>
.introduction-content-height{
    padding-bottom: 10rem;
}
@media screen and (max-width:639px) {
    .introduction-content-height{
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}

</style>